import React, { useRef } from 'react';
import Select from 'react-select';
import Content from './Translations.js';

const Filters = props => {
  const content = Content;
  const { offices, departments, state, lang, change, clearFilters } = props;

  const inputRef = useRef();

  const officeList = offices.map(el => {
    return {
      label: el.name,
      value: el.name,
      type: 'office'
    };
  });

  const departmentList = departments.map(el => {
    if (el) {
      return {
        label: el.name,
        value: el.name,
        type: 'department'
      };
    } else {
      return false;
    }
  });

  const { selectedOption } = state;

  return (
    <div className="jobs__filter filters">
      <div className="filters__cont">
        <input
          ref={inputRef}
          className="filters__item filters__item--search"
          type="text"
          placeholder={content[lang].position}
          onChange={change}
        />
      </div>
      <div className="filters__cont filters__cont--select">
        <Select
          className="filters__item filters__item--office"
          classNamePrefix="filters__select"
          isSearchable
          placeholder={content[lang].office}
          value={state.filters.current.type === 'office' ? selectedOption : null}
          onChange={change}
          options={officeList}
        />

        <Select
          className="filters__item filters__item--department"
          classNamePrefix="filters__select"
          isSearchable
          placeholder={content[lang].team}
          value={state.filters.current.type === 'department' ? selectedOption : null}
          onChange={change}
          options={departmentList}
        />
      </div>
      {state.filters.current.value && (
        <button
          className="filters__clear-btn"
          onClick={() => {
            inputRef.current.value = '';
            clearFilters();
          }}
        >
          Clear Filters
        </button>
      )}
    </div>
  );
};

export default Filters;
